import "./TopBar.css";

type TopBarProps = {
    projectName?: string;
};

export const TopBar = ({ projectName = "Project Name" }: TopBarProps) => {
    return (
        <header className="topBar">
            <div className="projectPill">
                <img
                    src={require("../../assets/img/logo-neg.png")}
                    alt="Sparcli"
                    className="topLogo"
                />
                <h2 className="projectName">{projectName}</h2>
            </div>
        </header>
    );
};
